(function() {
    'use strict';
    
a3_cabin_reports.factory('GenericService',GenericService);
    
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name GenericService
    * @description 
    *    Generic add, edit or remove
    * @ngInject
    */
function GenericService(localStorageMD5Service) {

		var objectType = null ;
		var objectCallback = null;
		
		var service = 
		{  
			initiate : initiate,
			get : get,
			getOne : getOne,
			list : list,
			save : save,
			saveOne : saveOne,
			saveAll : saveAll,
			remove : remove,
			removeAll : removeAll,
			add : add,
			constructor : constructor,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			saveByFilter : saveByFilter,
			removeByFilter : removeByFilter
		};

        /**
         * initiate type and callback
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @memberof GenericService
         */
		function initiate(type,callback){
			objectType = type;
			objectCallback = callback;
		}
		
        /**
         * Get the requested object
         * @memberof GenericService
         * @param {number} id The unique identifier
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} result
         */
		function get(id,type,callback){
			initiate(type,callback);
			var objects = list(type,callback);
			if (objects == null)
				return null;
		
			var result = null;
			var arrayLength = objects.length;
			for (var i = 0; i < arrayLength; i++) {
				if (objects[i].GetId() == id) {
					result = objects[i];
					break;
				}
			}
			
			return result;
		}

         /**
         * Get all the objects
         * @memberof GenericService
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {array} objectList
         */
		function list(type,callback){
			initiate(type,callback);
			var objects = localStorageMD5Service.get(objectType);
			return fromObjectList(objects,callback);
		}

        /**
         * Get the unique object of this storage
         * @memberof GenericService
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} result
         */
		function getOne(type,callback){
			initiate(type,callback);
			var object = localStorageMD5Service.get(objectType);
			return fromObject(object,callback);
		}
			
        /**
         * Save the unique object of this storage
         * @memberof GenericService
         * @param {object} obj The object to save
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor\
         */
		function saveOne(obj,type,callback){
			localStorageMD5Service.set(type,obj);
		}

        /**
         * update the  object
         * @memberof GenericService
         * @param {object} object The object to save
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor\
         */
		function save(object,type,callback){
			initiate(type,callback)
			var objects = list(type,callback);
			var updatedobject = fromObject(object,callback);
			var arrayLength = objects.length;

			for (var i = 0; i < arrayLength; i++) {
				if (objects[i].GetId() == updatedobject.GetId())	{
					objects[i] = updatedobject;
					break;
				}
			}

			saveAll(objects,type,callback);
		}
		
        /**
         * Save the  objects 
         * @memberof GenericService
         * @param {array} objects The objects to save
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor\
         */
		function saveAll(objects,type,callback){
			initiate(type,callback);
			localStorageMD5Service.set(objectType,objects);
		}

        /**
         * remove the  object based on its unique identifier
         * @memberof GenericService
         * @param {number} Id  The unique identifier
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         */
		function remove(Id,type,callback){
			initiate(type,callback);
			var objects = list(type,callback);
			var newObjects = [];
			var arrayLength = objects.length;

			for (var i = 0; i < arrayLength; i++) {
				if (objects[i].GetId() != Id) {
					newObjects.push(objects[i])
				}
			}
		
			saveAll(newObjects,type,callback);
		}

        /**
         * remove all the  objects
         * @memberof GenericService
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         */
		function removeAll(type,callback){
			initiate(type,callback);
			localStorageMD5Service.remove(objectType);
		}
		
        /**
         * add  the  object
         * @memberof GenericService
         * @param {object} object The object to save
         * @param {string} type A string which identifies the local storage name
         * @param {function} callback A callback function that behaves as a constructor
         */
		function add(obj,type,callback){
			var objects = list(type,callback);
			objects.push(obj);
			saveAll(objects,type,callback);
		}
		
        /**
         * Create a new  object
         * @memberof GenericService
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} object
         */
		function constructor(callback){
			var object = new callback();
			return object;
		}
		
        /**
         * Extend given object 
         * @memberof GenericService
         * @param {object} obj The object that will be extended
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} object
         */
		function fromObject(obj,callback){
			if (obj==null) return null;
			var object = new callback();
			angular.extend(object, obj);
			return object;
		};
		
        /**
         * Extend given object list
         * @memberof GenericService
         * @param {array} objList The list of objects that will be extended
         * @param {function} callback A callback function that behaves as a constructor
         * @returns {object} objList
         */
		function fromObjectList(objList,callback) {
			if (objList==null)
				return [];
			
			var arrayLength = objList.length;
			var objects = new Array();
			
			for (var i = 0; i < arrayLength; i++) {
				objects.push(fromObject(objList[i],callback));
			}
			
			return objects;
		};

		/**
		 * Update object in local storage - Search it by filters
		 * @param {object} object The objects to save
		 * @param {array} filters Array of property-value pairs to act as ids 
		 * @param {string} type A string which identifies the local storage name
		 * @param {function} callback  A callback function that behaves as a constructor
		 */
		function saveByFilter(object, filters, type, callback) {
			initiate(type,callback)
			var objects = list(type,callback);
			var updatedobject = fromObject(object,callback);
			var arrayLength = objects.length;

			for (var j = 0; j < arrayLength; j++) {
				var retVal = true;
				var storageObject = objects[j];
				for(var i = 0; i < filters.length; i++){
					if(storageObject[filters[i][0]] != filters[i][1]){
						retVal = false;
						break;
					}
				}
				if(retVal){
					objects[j] = updatedobject;
					break;
				}
			}

			saveAll(objects,type,callback);
		}

		/**
		 * Remove object from local strage - Search it by filters
		 * @param {array} filters Array of property-value pairs to act as ids 
		 * @param {string} type A string which identifies the local storage name
		 * @param {function} callback  A callback function that behaves as a constructor
		 */
		function removeByFilter(filters, type, callback) {
			initiate(type,callback)
			var objects = list(type,callback);
			var newObjects = [];
			var arrayLength = objects.length;

			for (var j = 0; j < arrayLength; j++) {
				var storageObject = objects[j];
				for(var i = 0; i < filters.length; i++){
					if(storageObject[filters[i][0]] != filters[i][1]){
						newObjects.push(storageObject)
						break;
					}
				}
			}
			saveAll(newObjects,type,callback);
		}

	return service;
	}
    
})();
